module.exports = __webpack_public_path__ + "static/profile-pic.fd8504f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile-pic.jpg
// module id = 296
// module chunks = 35783957827783 107818501498521